import React, { useState, useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { Container, Grid } from '@material-ui/core'
import EvaluatorModal from '../../components/EvaluatorModal'
import PlayQuiz from '../../components/PlayQuiz'
import { isMobileOnly } from 'react-device-detect'
import questions from './questionAnswers'
import { mobileScreen } from "../../utils/styleUtils"
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const QuizScreen = ({ classes, setCurrentScreen, givenAnswers, setGivenAnswers }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(mobileScreen(theme));

  const [dragStarted, setDragStarted] = useState(false)
  const [answers, setAnswers] = useState([])
  // const [givenAnswers, setGivenAnswers] = useState([])
  const [prevAnswer, setPrevAnswer] = useState(false)
  const [answeredCorrectly, setAnsweredCorrectly] = useState(null)
  const [openEvaluatorModal, setOpenEvaluatorModal] = useState(false)
  const [questionIndex, setQuestionIndex] = useState(0)
  const [reset, setReset] = useState(false)

  const onSubmit = (newAnswer) => {
    setOpenEvaluatorModal(newAnswer)
  }

  const nextQuestion = () => {
    setPrevAnswer(openEvaluatorModal)
    setOpenEvaluatorModal(null)
    setGivenAnswers([...givenAnswers, answeredCorrectly])
    if (questionIndex >= questions.length - 1)
      setCurrentScreen("Result")
    else {
      setAnswers([...answers, questions[questionIndex]])
      setQuestionIndex(questionIndex + 1)
    }
    setReset(!reset)
  }

  useEffect(() => {
    setTimeout(() => {
      setAnsweredCorrectly(null)
      console.log("AnsweredCorrectly", answeredCorrectly)
      setPrevAnswer(null)
    }, 1000)
  }, [questionIndex])

  console.log("AnsweredCorrectly", answeredCorrectly)
  return (
    <Grid>
      <Grid className={`${classes.quizScreenContainer} ${dragStarted && 'overlay'}`}>
        <Container maxWidth={isMobile ? 'sm' : 'md' } style={{ paddingTop: isMobile ? '0.5rem' : '4rem' }}>
          <PlayQuiz
            dragStarted={dragStarted}
            setDragStarted={setDragStarted}
            onSubmit={onSubmit}
            currentQuestion={questions[questionIndex]}
            prevQuestion={questionIndex > 0 && questions[questionIndex - 1]}
            prevAnswer={prevAnswer}
            answers={answers}
            setAnsweredCorrectly={setAnsweredCorrectly}
            answeredCorrectly={answeredCorrectly}
            key={reset}
          />
        </Container>
      </Grid>
      {openEvaluatorModal && <EvaluatorModal nextQuestion={nextQuestion} question={questions[questionIndex]} answeredCorrectly={answeredCorrectly}/>}
    </Grid>
  )
}

export default withStyles(styles)(QuizScreen)
